import { useRead } from '@spotify-internal/creator-data-loading';

import { useCurrentArtist } from '../../../features/artists';

import { artistProfileLoader } from '../artistProfileLoader';

export function useCurrentArtistProfile() {
  const currentArtist = useCurrentArtist();

  return useRead(artistProfileLoader, currentArtist.id);
}
